import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid2 as Grid,
  Button,
  useTheme,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { ExternalLink } from "../../components/ExternalLink";
import { PaymentDetailsModel } from "@attelas/shared";
import { formatAmount } from "../../utils/formatAmount";
import { formatDate } from "../../utils/formatDate";
import { StyledTable } from "./styled";

type Props = {
  payments: PaymentDetailsModel[];
  supplierLink?: string;
};

const MAX_VISIBLE_PAYMENTS = 5;

export function Payments({ payments, supplierLink }: Props) {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const visiblePayments = payments.slice(0, MAX_VISIBLE_PAYMENTS);
  const hasMore = payments.length >= MAX_VISIBLE_PAYMENTS;

  return (
    <Accordion defaultExpanded disableGutters>
      <AccordionSummary
        expandIcon={<KeyboardArrowDownIcon />}
        aria-controls="payments-panel-content"
        id="payments-panel"
      >
        <Typography variant="h3">Payments</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <TableContainer>
          <StyledTable size="small" aria-label="payment table">
            <TableHead>
              <TableRow>
                <TableCell>Payment</TableCell>
                <TableCell align="right">Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {visiblePayments.map((payment) => (
                <TableRow key={payment.id}>
                  <TableCell>
                    <ExternalLink href={payment.link}>Payment</ExternalLink>
                    <Typography>{formatAmount(payment.amount)}</Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography>{formatDate(payment.date, { day: "numeric", month: "short" })}</Typography>
                    <Typography>{payment.accountName}</Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </StyledTable>
        </TableContainer>
        {hasMore && (
          <Grid
            container
            justifyContent="center"
            sx={{ pt: 0.5, backgroundColor: isDarkMode ? "common.black" : "common.white" }}
          >
            <Button variant="text" size="small" href={supplierLink ?? ""} target="_blank" endIcon={<OpenInNewIcon />}>
              See more
            </Button>
          </Grid>
        )}
      </AccordionDetails>
    </Accordion>
  );
}
